import { render } from "./NewHeaderView.vue?vue&type=template&id=4a1f4c62&scoped=true"
import script from "./NewHeaderView.vue?vue&type=script&lang=js"
export * from "./NewHeaderView.vue?vue&type=script&lang=js"

import "./NewHeaderView.vue?vue&type=style&index=0&id=4a1f4c62&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1f4c62"]])

export default __exports__